import { useMemo } from 'react'

import { useSelector } from 'react-redux'
import { Card, Tag } from 'antd'
import {
  faAt,
  faGlobe,
  faIdBadge,
  faLocationArrow,
  faPen,
  faPhone
} from '@fortawesome/pro-solid-svg-icons'
import { isFunction } from 'lodash'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import IconLabel, { FontSizes } from '../../icons/IconLabel'
import ClickableIcon from '../../antd/Buttons/ClickableIcon'
import EntityBadge from '../Badges/EntityBadge'
import { SchoolProperties } from '../../../utils/entities/school'
import { getIdOrNull, isObject, isOptimistic } from '../../../utils'

const { ABBREVIATION, ADDRESS, COUNTRY, EMAIL, NAME, PHONE_NUMBER } = SchoolProperties

const getCountryName = (country, countries) => {
  if (isObject(country) && country.name) {
    return country.name
  }

  return countries.find(c => getIdOrNull(c) === getIdOrNull(country))?.name ?? null
}

const SchoolCard = ({ countries = [], editTitle = 'internship_request_portal.school.edit', school, onEdit }) => {
  const t = useSelector(selectTranslate)

  const countryName = useMemo(() => getCountryName(school[COUNTRY], countries), [school[COUNTRY], countries])

  const toBeValidated = isOptimistic(school)

  return (
    <Card
      className='school-card'
      size='small'
      title={
        <div className='flex-row ai-ctr' style={{ gap: 8 }}>
          <span>{school[NAME]}</span>
          {!toBeValidated && <EntityBadge entity={school} size='sm' withTooltip />}
          {toBeValidated && <Tag color='orange'>{t('internship_request_portal.school.to_be_validated')}</Tag>}
        </div>
      }
      extra={toBeValidated && isFunction(onEdit) && (
        <ClickableIcon icon={faPen} size='small' title={t(editTitle)} onClick={onEdit} />
      )}
    >
      {school[ABBREVIATION] && <IconLabel icon={faIdBadge} text={school[ABBREVIATION]} fontSize={FontSizes.SMALL} />}
      {school[ADDRESS] && <IconLabel icon={faLocationArrow} text={school[ADDRESS]} fontSize={FontSizes.SMALL} />}
      {countryName && <IconLabel icon={faGlobe} text={countryName} fontSize={FontSizes.SMALL} />}
      {school[EMAIL] && <IconLabel icon={faAt} text={school[EMAIL]} fontSize={FontSizes.SMALL} />}
      {school[PHONE_NUMBER] && <IconLabel icon={faPhone} text={school[PHONE_NUMBER]} fontSize={FontSizes.SMALL} />}
    </Card>
  )
}

export default SchoolCard
